import { SwipePreview } from '~/components/SwipePreview';

export default [
    {
        heading: 'Flere klikk med AI-genererte titler',
        text: 'Vi har lansert en ny funksjon som gjør at vi kan generere overskrifter til Blink-annonsene. Overskriftene blir generert av en kunstig intelligens som har blitt trent til å forstå hva som er viktig i en eiendomsannonse. Disse AI-genererte overskriftene vil konkurrere med den originale kampanjetittelen. Den beste overskriften, den som gir mest verdi til annonsen din, vil bli valgt ut ved hjelp av en sofistikert algoritme.',
        imageText: 'Her ser du et eksempel på hvordan det ser ut i praksis.',
        images: [
            {
                url: '/blink/images/blink-gen-titles-2.webp',
                alt: 'En standard Blink-annonse',
            },
            {
                url: '/blink/images/blink-gen-titles-3.webp',
                alt: 'Eksempel på AI-genererte overskrifter',
            },
            {
                url: '/blink/images/blink-gen-titles-4.webp',
                alt: 'Eksempel på AI-genererte overskrifter',
            },
            {
                url: '/blink/images/blink-gen-titles-5.webp',
                alt: 'Eksempel på AI-genererte overskrifter',
            },
        ],
    },
    {
        heading: 'Nytt design',
        text: 'Vi har lansert nytt design på Blink - yay! Bilder er ekstremt viktig og det som gir en stopp-effekt. Derfor vil vi vie så mye plass som mulig til det visuelle i det nye designet, og at teksten kun viser det viktigste. At vi har tatt med visningsdato i annonsene, gir en “sense of urgency” for de som ser annonsen.',
        imageText:
            'Vi har testet utallige varianter av ulike design og annonser for å komme fram til det resultatet vi har i dag. Det siste bildet viser det nye designet vi har lansert.',
        images: [
            {
                url: '/blink/images/nytt-design-control.webp',
                alt: 'Kontroll',
            },
            {
                url: '/blink/images/nytt-design-reklame.webp',
                alt: 'Reklame',
            },
            {
                url: '/blink/images/nytt-design-with.webp',
                alt: 'Med',
            },
            {
                url: '/blink/images/nytt-design-hyphen.webp',
                alt: 'Bindestrek',
            },
        ],
    },
    {
        heading: 'Nå kan du sveipe i Blink-annonser ',
        text: 'Vi har lansert sveipefunksjon i Blink-annonser på enkelte mobilplasseringer. Slik kan boligkjøpere få et enda bedre inntrykk av boligen før de klikker seg videre til annonsen. Bildene hentes fra annonsen ved hjelp av bildeanalyse, og i tillegg viser vi kart og informasjon om megler i bildekarusellen. Vi håper du liker det nye designet!',
        imageText: 'Nå har boligkjøpere endelig mulighet til å se flere bilder ved å bruke sveipfunksjonen',
        images: [],
        content: <SwipePreview />,
    },
    {
        heading: 'Blink-annonser på Instagram ',
        text: 'Nå viser vi også Blink-annonsen på Instagram.',
        imageText: 'Vi har åpnet for muligheten til å annonsere på på Instagram. Jippi!!!',
        images: [
            {
                url: '/blink/images/instagram-ad-1.webp',
                alt: 'Instagram-annonse 1',
            },
            {
                url: '/blink/images/instagram-ad-2.webp',
                alt: 'Instagram-annonse 2',
            },
        ],
    },
    {
        heading: 'Nytt design på nybygg',
        text: 'For nybyggannonser viser vi nå også status for byggeprosessen; fra planlegging av prosjektet til boligen e er klare for overtakelse. ',
        imageText: 'På de nye nybyggannonsene viser vi hvor i byggeprosessen prosjektet er. ',
        images: [
            {
                url: '/blink/images/planning-stage-no-cta.webp',
                alt: 'Planleggingsstadie',
            },
            {
                url: '/blink/images/sales-start.webp',
                alt: 'Salgsstart',
            },
            {
                url: '/blink/images/building-start.webp',
                alt: 'Byggestart',
            },
            {
                url: '/blink/images/building-finished.webp',
                alt: 'Bygg ferdig',
            },
        ],
    },
    {
        heading: 'Reklame-look',
        text: 'Vi hadde fått noen tilbakemeldinger på at designet på Blink-annonsene var litt kjedelig, så vi ville prøve oss på en litt mer crazy “reklamete-look”. Som dette eksempelet hvor vi testet med å legge tekst og logo oppå bildet av boligen. Resultatene viste oss derimot at verken dette designet eller de mange andre variantene vi testet ble så godt mottatt av målgruppen.',
        imageText: 'Verden var ikke klar for dette designet enda.',
        images: [
            {
                url: '/blink/images/reklame-look.webp',
                alt: 'Reklame-look',
            },
        ],
    },
];
